import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { Page } from '../../Page';
import { useEffect } from 'react';
import { resetButtons, setBackButtonVisible } from '../menu/menuSlice';
import styles from './Wizard.module.css'
import { BackButton } from '../menu/BackButton';

export function Welcome() {
    const dispatch = useAppDispatch() 
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
    }) 
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.content}>
            <h1>PartyPlanner</h1>
            <br></br>
            <h2> Welcome to PartyPlanner! This is a step by step tool that will help you create the perfect party for any occasion.</h2>
            <br></br>
            <h2>Click next to get started</h2>
            </div>
            <br></br>
            <button className={styles.nextButton} onClick={() => {
                navigate('/CreateName')
            }}
            onKeyDown={e => e.key === 'Enter' ? navigate('/createName'): 
                ''}>Next</button>
        </Page>
    )
}